<script lang="ts">
  import CloseButton from "../../assets/icons/close.svg";

  export let header: string | null = null;
  export let opened: boolean = false;

  let dialog: HTMLDialogElement;
  export let fullscreen: boolean = false;

  $: if (!!opened && !!dialog) dialog.showModal();

  function resetModal(): void {
    opened = false;
    dialog.close();
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<dialog
  bind:this={dialog}
  on:close={resetModal}
  on:click|self={resetModal}
  class:fullscreen
>
  <div on:click|stopPropagation>
    <div class="header">
      {#if !!header}
        <h1>{header}</h1>
      {/if}

      <img
        class="close"
        on:click={resetModal}
        src={CloseButton}
        alt="Close button"
      />
    </div>

    <slot />
  </div>
</dialog>

<style lang="scss">
  @import "src/lib/styles/variables";
  @import "src/lib/styles/mixins";

  .header {
    display: flex;
    justify-content: space-between;

    & > img {
      margin-left: auto;
    }
  }

  h1 {
    margin: 0 0 1rem;
    font-size: $font-size-large;
    line-height: 1.5rem;
    color: $color-primary;
    font-family: "Roboto";
    font-weight: 700;
    margin-right: 0.75rem;
  }

  .close {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  dialog {
    max-width: 100%;
    border-radius: 0.2em;
    border: none;
    padding: 0;
    margin-left: 1.5rem;
    margin-right: 1.5rem;

    &.fullscreen {
      margin: auto auto 0;
    }
  }
  dialog::backdrop {
    background: rgba(0, 0, 0, 0.3);
  }
  dialog > div {
    padding: 1em;
  }
  dialog[open] {
    animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  @keyframes zoom {
    from {
      transform: scale(0.95);
    }
    to {
      transform: scale(1);
    }
  }
  dialog[open]::backdrop {
    animation: fade 0.2s ease-out;
  }
  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @include desktop {
    dialog {
      margin: auto;
      max-width: 32em;

      &.fullscreen {
        margin: auto;
        max-width: 90%;
      }
    }
  }
</style>
